module.exports = __webpack_public_path__ + "img/linkedin-white.be7794df.svg";